import { capitalize, isEmpty } from 'lodash'

export const capEveryWord = (address) => {
  const words = address.split(' ')
  return words.reduce((acc, word) => {
    if (!acc) return capitalize(word)
    return `${acc} ${capitalize(word)}`
  }, '')
}

// Modified to accept t function as parameter and use correct prefix
export const getSpecialtyOptions = (t) => [
  { value: 'mail_order', label: t('visitCreation.pharmacy.specialty.mailOrder') },
  { value: 'retail', label: t('visitCreation.pharmacy.specialty.retail') },
  { value: 'specialty', label: t('visitCreation.pharmacy.specialty.specialty') },
  { value: 'long_term_care', label: t('visitCreation.pharmacy.specialty.longTermCare') },
  { value: 'open_24', label: t('visitCreation.pharmacy.specialty.open24') },
]

// Modified to accept t function as parameter and use correct prefix
export const getDistanceOptions = (t) => [
  { value: '', label: t('visitCreation.pharmacy.distance.select'), disabled: true },
  { value: 5, label: t('visitCreation.pharmacy.distance.within5') },
  { value: 10, label: t('visitCreation.pharmacy.distance.within10') },
  { value: 25, label: t('visitCreation.pharmacy.distance.within25') },
  { value: 50, label: t('visitCreation.pharmacy.distance.within50') },
]

// Helper function to get specialty key from bit
const getSpecialtyKeyFromBit = (bit) => {
  const bitNumber = parseInt(bit)
  switch (bitNumber) {
    case 1:
      return 'mailOrder'
    case 8:
      return 'retail'
    case 16:
      return 'specialty'
    case 32:
      return 'longTermCare'
    case 64:
      return 'open24'
    default:
      return ''
  }
}

// Modified to accept t function as parameter and use correct prefix
export const getSpecialtyBitMap = (t) => ({
  1: t('visitCreation.pharmacy.specialty.mailOrder'),
  8: t('visitCreation.pharmacy.specialty.retail'),
  16: t('visitCreation.pharmacy.specialty.specialty'),
  32: t('visitCreation.pharmacy.specialty.longTermCare'),
  64: t('visitCreation.pharmacy.specialty.open24'),
})

// Modified to accept t function as parameter
export const getPharmacySpecialties = (pharmacy, t) => {
  if (!pharmacy) return ''

  // Use the provided translation function
  const currentSpecialtyBitMap = getSpecialtyBitMap(t)

  const specialties = Object.keys(currentSpecialtyBitMap).reduce((acc, bit) => {
    const hasBit = bit & pharmacy.specialty
    if (hasBit) {
      if (!acc) return currentSpecialtyBitMap[bit]
      return `${acc}, ${currentSpecialtyBitMap[bit]}`
    }
    return acc
  }, '')
  return specialties
}

export const pharmacyLocation = (pharmacy) => {
  if (!pharmacy || !pharmacy.point || isEmpty(pharmacy.point.coordinates)) {
    return null
  }
  const [lng, lat] = pharmacy.point.coordinates
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}&label=${pharmacy.store_name}`
}
